module.exports = __webpack_public_path__ + "3b7f416a36ea3b3e1db4e0525b73aadf.svg";